import { buildStandingsFromFixtures } from "./standingsFromFixtures";

/** Youth league: soccer scoring (3 pts win, 1 draw). */
export function buildYouthStandingsFromFixtures(fixtures, allTeams) {
  return buildStandingsFromFixtures(fixtures, allTeams);
}
